<div
  class="dialog-container confirmation-container"
  fxLayout="column"
  *ngIf="info"
>
  <mat-dialog-actions fxLayoutAlign="center center">
    <h2 mat-dialog-title>{{ info.title | translate }}</h2>
  </mat-dialog-actions>
  <mat-dialog-content class="text-center alert-text" fxFlex>{{
    info?.message
  }}</mat-dialog-content>
  <div
    class="actions-container"
    fxLayout
    fxLayoutAlign="center center"
    fxLayoutGap="24px"
  >
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      {{ info.okText | translate }}
    </button>
  </div>
</div>
